import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Icon from "@/components/Icon";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import LongForm from "@/components/LongForm";
import { SEO_CONTENT } from "@/data/seoContent";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <>
      <Seo
        title="Nos Services de Recherche de Fuite d'Eau | FuiteX"
        description="Fuite de canalisation, piscine, chauffage au sol, dégât des eaux : FuiteX intervient sur tous types de fuites avec des méthodes non destructives."
        canonical="/services"
      />
      <PageHero
        overline="Nos services"
        titleLines={["Nos services de", "recherche de fuite d'eau"]}
        subtitle="Fuite de canalisation, piscine, chauffage au sol, dégât des eaux : chaque situation a sa méthode. Nous intervenons sans destruction, partout en Île-de-France."
        breadcrumb={[{ label: "Nos services" }]}
      />

      <section className="bg-white">
        {SERVICES.map((s, i) => (
          <div key={s.slug} className={i % 2 === 1 ? "bg-mist" : "bg-white"}>
            <div className="container-x py-20 grid lg:grid-cols-12 gap-8 items-start">
              <Reveal className="lg:col-span-3">
                <span className="text-7xl font-black text-aqua/15 leading-none">{s.num}</span>
                <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-aqua/10 text-aqua">
                  <Icon name={s.icon} size={24} />
                </div>
              </Reveal>
              <Reveal delay={0.1} className="lg:col-span-9">
                <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-ink">{s.title}</h2>
                <p className="mt-4 text-lg text-ink/70 leading-relaxed max-w-3xl">{s.text}</p>
                <Link to="/contact" data-testid={`service-cta-${s.slug}`} className="mt-6 inline-flex items-center gap-2 text-aqua font-bold hover:gap-3 transition-all">
                  Demander un devis pour ce service <ArrowRight size={18} />
                </Link>
              </Reveal>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-mist py-24">
        <div className="container-x">
          <LongForm data={SEO_CONTENT.services} />
        </div>
      </section>

      <CTASection />
    </>
  );
}
